<footer class="footer-modern">
  <div class="footer-modern__inner">

    <span class="footer-modern__copy">
      {{ appName }} <span class="footer-modern__version">v{{ version }}</span>
      &copy; {{ anio | date:'yyyy' }}
      <a href="{{ webUrl }}" target="_blank" class="footer-modern__brand">{{ ciaName }}</a>
    </span>

    @if (enableSocialLink) {
      <div class="footer-modern__social">
        @if (TWITTER_LINK !== '') {
          <a [href]="TWITTER_LINK" target="_blank" class="footer-modern__social-link"><i class="sdx sdx-twitter"></i></a>
        }
        @if (YOUTUBE_LINK !== '') {
          <a [href]="YOUTUBE_LINK" target="_blank" class="footer-modern__social-link"><i class="sdx sdx-youtube"></i></a>
        }
        @if (FACEBOOK_LINK !== '') {
          <a [href]="FACEBOOK_LINK" target="_blank" class="footer-modern__social-link"><i class="sdx sdx-facebook"></i></a>
        }
        @if (INSTAGRAM_LINK !== '') {
          <a [href]="INSTAGRAM_LINK" target="_blank" class="footer-modern__social-link"><i class="sdx sdx-instagram"></i></a>
        }
        @if (LINKEDIN_LINK !== '') {
          <a [href]="LINKEDIN_LINK" target="_blank" class="footer-modern__social-link"><i class="sdx sdx-linkedin"></i></a>
        }
      </div>
    }

    <nav class="footer-modern__links">
      <a [routerLink]="['/'+aboutPath]" class="footer-modern__link">{{ 'label.about-us' | transloco }}</a>
      <a [routerLink]="['/'+privacyPolicyPath]" class="footer-modern__link">{{ 'label.privacy-policy' | transloco }}</a>
    </nav>

  </div>
</footer>
